import { useParams } from 'react-router-dom';

import { CreateAppPage } from '~/components/pages/CreateAppPage';
import { DashboardTemplate } from '~/components/templates/DashboardTemplate';

export const CreateAppRoute: React.FC = () => {
  const { organizationId } = useParams();

  return (
    <DashboardTemplate organizationId={organizationId}>
      <CreateAppPage organizationId={organizationId} />
    </DashboardTemplate>
  );
};
